import React, { FC, memo } from 'react';
import { SubjectIdContext } from '@surveycake/react-logic-engine';
import {
  NestProps,
  NestParentProps,
  NestChildsProps,
  NestChildProps
} from './types';

export function createNest(
  Child: FC<NestChildProps>,
  Parent?: FC<NestParentProps>
) {
  function Childs({ childIds, options }: NestChildsProps) {
    return (
      <>
        {childIds.map(childId => (
          <SubjectIdContext.Provider key={childId} value={childId}>
            <Child options={options} />
          </SubjectIdContext.Provider>
        ))}
      </>
    );
  }

  function Nest({ childIds, options }: NestProps) {
    const childs = <Childs childIds={childIds} options={options} />;

    if (!Parent) {
      return childs;
    }

    return <Parent options={options}>{childs}</Parent>;
  }

  return memo(Nest);
}
